import axios from "axios";
import Swal from "sweetalert2";

interface ApiError {
  message: string;
}

export const handleError = (error: unknown) => {
  if (axios.isAxiosError(error) && error.response) {
    const errorData = error.response.data as ApiError;
    Swal.fire({
      title: "Error!",
      text: errorData.message || "Request failed",
      icon: "error",
    });
  } else {
    Swal.fire({
      title: "Error!",
      text: "An unexpected error occurred",
      icon: "error",
    });
  }
};
